const COMPONENT_INGREDIENT_TYPES = {
  DEFINITE: 'DEFINITE',
  PROBABLE: 'PROBABLE',
}

export default COMPONENT_INGREDIENT_TYPES
